<template>
  <button
    @click="handleClick"
    @focus="handleFocus"
    @blur="handleBlur"
    :class="[
      type,
      size,
      disabled ? 'disabled' : '',
      loading ? 'loading' : '',
      icon ? 'icon' : '',
      fullwidth ? 'fullwidth' : '',
      flat ? 'flat' : '',
      tooltipOnDisabled && disabled ? 'disabled-tooltip' : ''
    ]"
    :disabled="disabled || loading ? true : false"
    :type="submit ? 'submit' : 'button'"
    :style="{ color: color }"
    :title="title"
    class="button"
  >
    <i v-if="icon" :class="'icon-' + icon" />
    <slot v-if="!icon" />
    <span v-if="loading" class="loading-wrapper"
      ><i class="icon-loading animate-spin"
    /></span>
    <span
      v-if="tooltipOnDisabled"
      :style="[
        tooltipOnDisabledFixed === 'right'
          ? { right: '0', left: 'auto', transform: 'none' }
          : {}
      ]"
      class="tooltip-on-disabled animated fadeIn"
    >
      {{ tooltipOnDisabled }}
    </span>
  </button>
</template>

<script>
export default {
  props: [
    "text",
    "type",
    "disabled",
    "icon",
    "loading",
    "submit",
    "size",
    "color",
    "fullwidth",
    "flat",
    "title",
    "tooltipOnDisabled",
    "tooltipOnDisabledFixed"
  ],
  data() {
    return {};
  },
  methods: {
    handleClick($event) {
      this.$emit("click", $event);
    },
    handleFocus() {
      this.$emit("focus");
    },
    handleBlur() {
      this.$emit("blur");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../common/_variables.scss";

.button {
  color: white;
  font-family: $font-secondary;
  font-size: 0.8rem;
  padding: 12px 40px;
  border-radius: 20px;
  position: relative;
  cursor: pointer;

  &:hover {
    @include shadow(0 2px 4px 0 rgba(0, 0, 0, 0.15));
  }

  -webkit-appearance: none;
  -moz-appearance: none;
  border: none;
  outline: none;

  transition: box-shadow 0.3s;

  &.small {
    padding: 10px 25px;
  }

  &.fullwidth {
    width: 100%;
  }

  &.primary {
    background-color: $color-primary;
    &:active {
      background-color: #00666f;
    }
  }
  &.secondary {
    background-color: white;
    color: $color-primary;
    border: solid 1px #e6e6e6;
    transition: background-color 0.3s, box-shadow 0.3s;
    &:active {
      background-color: #f8fafa;
    }
    &.icon.default i:before {
      background: linear-gradient(to bottom, #00a7b0, $color-primary);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    &.icon.active {
      background-color: $color-primary;
      &.icon i:before {
        color: white;
        background-clip: none;
        -webkit-background-clip: none;
        -webkit-text-fill-color: white;
      }
    }
    &.disabled {
      background-color: white;
      color: #d9d9d9;
    }
    &.disabled.icon {
      background-color: white;
      i:before {
        color: #dfe1e1;
        background: transparent;
        background-clip: initial;
        -webkit-background-clip: initial;
        -webkit-text-fill-color: initial;
      }
      &:active {
        background-color: white;
      }
    }
    &.flat {
      color: black;
      padding: 10px;
      :hover .icon-close {
        box-shadow: none;
        transition: transform 0.3s ease;
        transform: rotate(90deg) translateX(-1px);
      }
      i {
        display: flex;
        font-size: 1.2rem;
      }
      i:before {
        color: black;
        background: transparent;
        background-clip: initial;
        -webkit-background-clip: initial;
        -webkit-text-fill-color: initial;
        margin: 0;
      }
    }
  }

  &.disabled {
    background-color: #e8e8e8;
    color: #bfbfbf;
    cursor: not-allowed;
    &:hover {
      box-shadow: none;
    }
    &:active {
      background-color: #a9a7a7;
    }
    & > span {
      pointer-events: none;
    }
  }

  &.icon {
    padding: 4px 5px 5px;
    border-radius: 50%;
    &.small {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1px 0 0 1px;
      i {
        font-size: 1rem;
        &:before {
          margin: 0;
        }
      }
    }
  }

  .hidden {
    opacity: 0;
  }
  .loading-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .icon-loading {
      font-size: 1.2rem;
    }
  }
  &.loading {
    cursor: not-allowed;
    color: transparent;
    &.secondary .loading-wrapper {
      color: $color-primary;
    }
    &.primary .loading-wrapper {
      color: white;
    }
  }
  img {
    margin-bottom: -5px;
  }
  &.disabled-tooltip:hover {
    cursor: help;
    .tooltip-on-disabled {
      display: block;
    }
  }
  .tooltip-on-disabled {
    display: none;
    width: 100%;
    width: 250px;
    position: absolute;
    top: 120%;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    border-radius: 8px;
    padding: 5px;
    border: 1px solid #dcdcdc;
    color: #868686;
    z-index: 10;
  }
}
</style>
